/**
 * LoadingScreen component - Full page loading indicator
 *
 * A centered loading screen combining the Spinner component with text.
 * Used for full-page loading states like authentication checks.
 *
 * Features:
 * - Centered layout with spinner and text
 * - Consistent with design system colors
 * - Accessible loading state
 */

import Spinner from './Spinner';

interface LoadingScreenProps {
  message?: string;
}

export default function LoadingScreen({ message = 'Chargement...' }: LoadingScreenProps) {
  return (
    <div className="min-h-screen bg-neutral-100 flex items-center justify-center">
      <div className="text-center">
        <div className="text-primary-600 mb-4 flex justify-center">
          <Spinner size="md" />
        </div>
        <p className="text-neutral-500">{message}</p>
      </div>
    </div>
  );
}
